import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GetSettlementPayload } from '../models/settlement.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettlementService implements OnDestroy{
  private url = 'api/settlements';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient) { }
  options = { headers: this.headers };
  private destroy$ = new Subject<void>();
  GetSettlements(
    startRow: number,
    endRow: number,
    date: { startDate: any, endDate: any },
    statuses?: string[],
    data?: GetSettlementPayload

  ) {
    date = this.convertAGgridDate(date);
    return this.http.get(`/${this.url
      }/GetSettlements?StartRow=${startRow}&EndRow=${endRow}${statuses.length ? statuses.map((status) => `&Statuses=${status}`).join("") : ""}${data?.payoutStatus ? "&PayoutStatus=" + data.payoutStatus : ""}${data?.type ? "&Type=" + data.type : ""}${data?.settlementsID ? "&SettlementId=" + data.settlementsID : ""}${data?.containSku ? "&HasSku=" + data.containSku : ""}${date?.startDate ? "&StartDate=" + date.startDate : ""}${date?.endDate ? "&EndDate=" + date.endDate : ""}`,
      this.options
    );
  }

  public payoutStatus() {
    return this.http.get(`/${this.url}/GetSettlementPayoutStatus`, this.options);
  }

  public SettlementType() {
    return this.http.get(`/${this.url}/GetSettlementType`, this.options);
  }

  DeleteGroup(payload){
    return this.http.post(`/${this.url}/DeleteGroups`, payload, this.options);
  }
  
  DeleteGroupItems(payload){
    return this.http.post(`/${this.url}/DeleteGroupItems`, payload, this.options);
  }
  
  SaveGroup(payload){
    return this.http.post(`/${this.url}/SaveGroup`, payload, this.options);
  }

  GetSettlementItemForGroup(payload){
    return this.http.get(`/${this.url}/GetSettlementItemForGroup?StartRow=${payload.startRow}&EndRow=${payload.endRow}${payload.globalSearch  ? "&GlobalSearch=" + payload.globalSearch : ""}`, this.options);
  }

  SaveGroupItems(payload){
    return this.http.post(`/${this.url}/SaveGroupItems`, payload, this.options);
  }

  private convertAGgridDate(filter) {
    var userTimezoneOffset = new Date().getTimezoneOffset() * 60000;
    filter.startDate = filter.startDate
      ? new Date(new Date(filter.startDate).setHours(0, 0, 0, 0) - userTimezoneOffset).toISOString().replace(" ", "T")
      : null;
    if (filter.endDate) {
      var date = new Date(filter.endDate);
      filter.endDate = new Date(new Date(filter.endDate).setHours(23, 59, 59, 59) - userTimezoneOffset).toISOString().replace(" ", "T")
    } else {
      filter.endDate = null;
    }
    return filter;
  }

  public GetGroups(payload) {
    return this.http.get(
      `/${this.url}/GetGroups?${payload.globalSearch ? "&GlobalSearch=" + payload.globalSearch : ""}&StartRow=${payload.startRow}&EndRow=${payload.endRow}`,
      this.options
    );
  }

  public GetSettlementDetails(payload) {
    return this.http.get(
      `/${this.url}/GetSettlementDetails?SettlementId=${payload.settlementId}&AmountType=${payload.amountType}&StartRow=${payload.startRow}&EndRow=${payload.endRow}`,
      this.options
    );
  }

  public GetSettlementData(payload) {
    return this.http.get(
      `/${this.url}/SettlementItemizedData?SettlementId=${payload.settlementId}&StartRow=${payload.startRow}&EndRow=${payload.endRow}&GroupBy=${payload.groupBy}${payload.globalSearch != null ? "&GlobalSearch=" + payload.globalSearch : ""}`,
      this.options
    );
  }

  public GetItemDetails(){
    return this.http.get(
      `/${this.url}/GetItemDetails`,
      this.options
    );
  }

  GetTopSettlementDetails(Id: number) {
    return this.http.get(
      `/${this.url}/GetTopSettlementDetails?SettlementId=${Id}`,
      this.options
    );
  }
  GetSettlementDetailsSummary(Id: number){
    return this.http.get(
      `/${this.url}/GetSettlementDetailsSummary?SettlementId=${Id}`,
      this.options
    );
  }
  
  GetSettlementTotal(payload){
    return this.http.get(
      `/${this.url}/SettlementItemizedDataTotal?SettlementId=${payload.settlementId}&GroupBy=${payload.groupBy}`,
      this.options
    );
  }

  SettlementItemizedDataDetail(payload){
  return this.http.get(`/${this.url}/SettlementItemizedDataDetail?SettlementId=${payload.settlementId}${payload.date != null ? "&Date=" + payload.date : ""}${payload.sku != null ? "&Sku=" + payload.sku : ""}&GroupBy=${payload.groupBy}`,
  this.options
  );
  }

  public GetGroupsBreakDown(payload) {
    return this.http.get(
      `/${this.url}/GetGroupsBreakDown?SettlementId=${payload.settlementId}${payload.globalSearch != null ? "&GlobalSearch=" + payload.globalSearch : ""}&StartRow=${payload.startRow}&EndRow=${payload.endRow}${payload.groupName != null ? "&GroupName=" + payload.groupName : ""}${payload.itemName != null ? "&ItemName=" + payload.itemName : ""}`,
      this.options
    );
  }

  SettlementOrderSidePanelDetail(OrderId:any){
    return this.http.get(
      `/${this.url}/SettlementOrderSidePanel?OrderId=${OrderId}`,
      this.options
    );
  }
   getSettlementItemizedData(payload) {
    return this.http.get(
      `/${this.url}/SettlementItemizedData?SettlementId=${payload.settlementId}&StartRow=${payload.startRow}&EndRow=${payload.endRow}&GroupBy=${payload.groupBy}${payload.globalSearch != null ? "&GlobalSearch=" + payload.globalSearch : ""}${payload.Date != null ? "&Date=" + payload.Date : ""}${payload.Sku != null ? "&Sku=" + payload.Sku : ""}`,
      this.options
    );
  }

  getPlData(payload) {
    return this.http.post(
      `/${this.url}/getPlData`,payload,this.options
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
